import { render } from "./PopupChatAI.vue?vue&type=template&id=86c17580&scoped=true"
import script from "./PopupChatAI.vue?vue&type=script&lang=js"
export * from "./PopupChatAI.vue?vue&type=script&lang=js"

import "./PopupChatAI.vue?vue&type=style&index=0&id=86c17580&scoped=true&lang=scss"

import exportComponent from "/var/www/test.adx-co.jp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86c17580"]])

export default __exports__